// extracted by mini-css-extract-plugin
export var content = "_ng-1";
export var divider = "_ng-0";